export const COMMISSIONS_SUMMARY_DATA = "COMMISSIONS_SUMMARY_DATA";

export const COMMISSIONS_PDF_FETCH_FAILED = "COMMISSIONS_PDF_FETCH_FAILED";
export const COMMISSIONS_XLS_FETCH_FAILED = "COMMISSIONS_XLS_FETCH_FAILED";

export const COMMISSIONS_FILE_DOWNLOAD_SUCCESS = "COMMISSIONS_FILE_DOWNLOAD_SUCCESS";

export const YTD_SUMMARY = "YTD_SUMMARY";

export const RESET_COMMISSIONS_SUMMARY = "RESET_COMMISSIONS_SUMMARY";
